import { render, staticRenderFns } from "./CustomerCTData.vue?vue&type=template&id=0002f1b0&scoped=true"
import script from "./CustomerCTData.vue?vue&type=script&lang=js"
export * from "./CustomerCTData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0002f1b0",
  null
  
)

export default component.exports